
















































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import {
  Button,
  Checkbox,
  CheckboxGroup,
  Form,
  FormItem,
  Option
} from 'element-ui';
import ModalCard from '@/components/layout/ModalCard.vue';

// types
import { BillItemFields } from '@/types/graphql/schemaTypes';

@Component({
  components: {
    ModalCard,
    'el-button': Button,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-checkbox-group': CheckboxGroup,
    'el-checkbox': Checkbox
  }
})
export default class BillItemSelect extends Vue {
  @Prop() selectedItems!: string[];
  @Prop({ default: () => { return []; }, type: Array }) shipmentBillItems!: BillItemFields[];
  @Prop({ default: false, type: Boolean }) open!: boolean;

  checkedItems = [];
  checkAll = false;
  isIndeterminate = false;

  close() {
    this.$emit('close');
  }

  handleCheckAllChange(isCheck: boolean) {
    this.checkedItems = isCheck
      // if checked add all item id
      ? this.shipmentBillItems.map(item => {
        return item.id;
      })
      // else empty it
      : [];
    this.isIndeterminate = false;
  }

  handleCheckedChange(id: string, isCheck: boolean) {
    if (isCheck) {
      // add item if checked
      this.checkedItems.push(id);
    } else {
      // find and remove item if uncheck
      const index = this.checkedItems.indexOf(id);

      if (index !== -1) {
        this.checkedItems.splice(index, 1);
      }
    }

    // re determinate check all checkbox state
    const checkedCount = this.checkedItems.length;
    const totalCount = this.shipmentBillItems.length;

    this.checkAll = checkedCount === totalCount;
    this.isIndeterminate =
      checkedCount > 0 && checkedCount < totalCount;
  }

  submit() {
    this.$emit('change', this.checkedItems);
    this.close();
  }

  @Watch('open')
  // watch open to bind selected item with existing one
  bindSelectedItem(open: boolean) {
    // skip if it's closing
    if (!open) {
      return;
    }

    // clear selection to prevent any deplicate item
    this.checkedItems = [];

    // loop over selected and call handleCheckedChange function to do it's magic
    this.selectedItems.forEach(id => {
      this.handleCheckedChange(id, true);
    });
  }
}
